import type { TFunction } from 'i18next';
import type { BranchDto } from 'korint-sdk';

export function getBranchDisplayName(branch: Pick<BranchDto, 'name' | 'branchType'>, t: TFunction) {
  return (
    branch.name?.trim() ||
    t(
      branch.branchType
        ? `branchContext.unnamed.${branch.branchType}`
        : 'branchContext.unnamedProject',
    )
  );
}

/** Keep the dashboard tab, query, and anchor when moving between policy versions. */
export function getPolicyBranchPath({
  policyId,
  currentBranchId,
  targetBranchId,
  pathname,
  search = '',
  hash = '',
}: {
  policyId: string;
  currentBranchId?: string;
  targetBranchId?: string;
  pathname: string;
  search?: string;
  hash?: string;
}) {
  const currentBase = `/policies/${policyId}${currentBranchId ? `/${currentBranchId}` : ''}`;
  const suffix =
    pathname === currentBase || pathname.startsWith(`${currentBase}/`)
      ? pathname.slice(currentBase.length)
      : '';
  return `/policies/${policyId}${targetBranchId ? `/${targetBranchId}` : ''}${suffix}${search}${hash}`;
}
